<div class="container">
  @if (isSingleDevice) {
  <h1>Reload Data Sender</h1>
  } @else {
  <h1>Update Device</h1>
  }

  @if (!isSingleDevice) {
  <mat-slide-toggle class="type-switch" [(ngModel)]="uploadCSV">Upload CSV</mat-slide-toggle>
  }
  @if (uploadCSV) {
  @if(files==null||files.length===0){
  <div class="uploadfilecontainer" (click)="fileInput.click()" appDragNDrop
    (onFileDropped)="handleDroppedFiles($event);">
    <input hidden type="file" id="fileInput" #fileInput (change)="onFileInput($event.target['files'])" multiple>
    Drag or Click to Upload
  </div>

  <p class="uploadHelp">What file types are allowed? <mat-icon class="pointer" matTooltip="Only CSV files are allowed">
      contact_support</mat-icon>
  </p>
  }@else {
  <div>
    <p>Selected File:</p>
    <div class="files-list">
      <p style="width: 100%;"> {{ files[0].name }} @if (!working) {
        <span class="material-icons delete-icon" (click)="deleteFile()">delete_forever</span>
        }
      </p>
    </div>
  </div>
  }
  }@else{
  <div class="inputs">
    <mat-form-field class="input">
      <mat-label>Device IP</mat-label>
      <input matInput [formControl]="ip" placeholder="Device IP">
      @if(ip.hasError('required')) {
      <mat-error>Device IP is required</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="input">
      <mat-label>Device Username</mat-label>
      <input matInput [formControl]="username" placeholder="Device Username">
      @if(username.hasError('required')) {
      <mat-error>Device Username is required</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="input">
      <mat-label>Device Password</mat-label>
      <input matInput type="password" [formControl]="password" placeholder="Device Password">
      @if(password.hasError('required')) {
      <mat-error>Device Password is required</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="input">
      <mat-label>Device FTP Port</mat-label>
      <input matInput [formControl]="ftpPort" placeholder="Device FTP Port">
      @if(ftpPort.hasError('required')) {
      <mat-error>Device FTP Port is required</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="input">
      <mat-label>Device FTP Username</mat-label>
      <input matInput [formControl]="ftpUsername" placeholder="Device FTP Username">
      @if(ftpUsername.hasError('required')) {
      <mat-error>Device FTP Username is required</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="input">
      <mat-label>Device FTP Password</mat-label>
      <input matInput type="password" [formControl]="ftpPassword" placeholder="Device FTP Password">
      @if(ftpPassword.hasError('required')) {
      <mat-error>Device FTP Password is required</mat-error>
      }
    </mat-form-field>
  </div>
  }
  @if (uploadCSV) {
  <div class="centered-button">
    <button [disabled]="updating" mat-raised-button (click)="downloadTemplate()">Download Template</button>
  </div>
  }
  <div class="buttons">
    <button [disabled]="updating" mat-raised-button (click)="updateDevice()">Update Device</button>
    <button mat-raised-button (click)="cancel()">Cancel</button>
  </div>
</div>
